import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutSuccess } from "../../redux/reducers/authSlice.js";
import { signOut } from "../../api/api";
import { useTranslation } from "react-i18next";

function LogoutPage() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    signOut().finally(() => {
      dispatch(logoutSuccess());
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      {t("logout")}
    </div>
  );
};

export default LogoutPage;